export default __webpack_public_path__ + "static/media/close-btn.585a16e0.svg";